import { createSelector } from 'reselect';

import { getAreActivitiesEnabled } from 'lib/selectors/getAreActivitiesEnabled';
import { getHasOpenActivity } from 'lib/selectors/getHasOpenActivity';
import { getLatestActivityMode } from 'lib/selectors/getLatestActivityMode';
import { JOB_STATUSES } from 'lib/constants';
import { getJobRun } from 'lib/selectors/getJobRun';
import { now, isBefore } from 'lib/utils/date';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';
import { getIsApmERPJobFlow } from 'lib/selectors/getIsApmERPJobFlow';

const getJobStatus = createSelector(
  [
    getAreActivitiesEnabled,
    getHasOpenActivity,
    getLatestActivityMode,
    getJobRun,
    getCurrentLaborTicket,
    getPostLaborUpdatesOnNats,
    getIsApmERPJobFlow,
  ],
  (
    areActivitiesEnabled,
    hasOpenActivity,
    latestActivityMode,
    jobRun,
    currentLaborTicket,
    natsFlowEnabled,
    isApmERPJobFlow
  ) => {
    // APM flow: type comes from the synthetic labor ticket set by the opdash display
    if (isApmERPJobFlow) {
      if (currentLaborTicket?.type) {
        return JOB_STATUSES[currentLaborTicket.type.toUpperCase()] || {};
      }
      return {};
    }

    if (areActivitiesEnabled) {
      // Async flow: labor ticket type is the source of truth
      if (natsFlowEnabled) {
        // In NATS mode, always use the labor ticket type as source of truth
        if (currentLaborTicket?.type) {
          return JOB_STATUSES[currentLaborTicket.type.toUpperCase()];
        }

        return {};
      }

      // Standard flow: use activity mode
      if (!hasOpenActivity || !latestActivityMode) {
        return {};
      }
      return JOB_STATUSES[latestActivityMode.toUpperCase()];
    }
    if (!jobRun) return {};

    const { setupEnd, setupTime } = jobRun;

    if (
      setupTime !== null &&
      (!setupEnd ||
        // check to handle case where setup is scheduled to end after now
        isBefore(now(), setupEnd))
    ) {
      return JOB_STATUSES.SETUP;
    }

    if (setupEnd) {
      return JOB_STATUSES.PRODUCTION;
    }

    return null;
  }
);

export { getJobStatus };
